import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddOrder from "../../components/OrderManagement/AddOrder";
import AddOrderV2 from "../../components/OrderManagement/AddOrderV2";
import AddOrderV3 from "../../components/OrderManagement/AddOrderV3";
// import PackageTable from "../../components/PackageSizes/PackageTable";
// import AddPackage from "../../components/PackageSizes/AddPackage";


const AddOrderPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Add Order" />
                {/* <AddEmailTemp /> */}
                {/* <AddPackage/> */}
                <AddOrderV3/>




            </MasterLayout>
        </>
    );
};

export default AddOrderPage;
